import { c as _c } from "react/compiler-runtime";
import { useMediaQuery as useMediaQueryUtil, isClient } from '@systemeio/util';
import { useMetadataFromServer } from 'shared/hooks/use-metadata-from-server';
import { getBreakpointsByServerDeviceType } from './utils/get-breakpoints-by-server-device-type';
const useMediaQuery = () => {
  const $ = _c(2);
  const {
    data: metaDataFromServer
  } = useMetadataFromServer();
  let t0;
  if ($[0] !== metaDataFromServer?.serverDeviceType) {
    t0 = !isClient() ? getBreakpointsByServerDeviceType(metaDataFromServer?.serverDeviceType) : undefined;
    $[0] = metaDataFromServer?.serverDeviceType;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const initialBreakpoints = t0;
  return useMediaQueryUtil(initialBreakpoints);
};
export default useMediaQuery;